var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormItem',{attrs:{"label":"活动规则","prop":"quantity"}},[_c('span',[_vm._v("第 2")]),_c('span',[_vm._v(" 件半价")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }